import { queryClient as appQueryClient } from '@/api/queryClient'
import { METRIC_TARGETS_QUERY_KEY } from '@/api/modules/metricTargetsKeys'

const METRIC_PATH = /^\/metrics\/([^/?#]+)/

/**
 * @param {string|undefined} urlPath - e.g. `/metrics/42?tab=targets`
 * @returns {string|null} the metric id in the path, else null
 */
export function metricIdFromPath(urlPath) {
  const match = typeof urlPath === 'string' ? METRIC_PATH.exec(urlPath) : null
  return match ? match[1] : null
}

/**
 * Refreshes the React Query caches a confirmed AI draft made stale. Only a
 * target needs it today (ClickUp 86e3g6ww3): the metric page's Targets table
 * (`['metric-targets', metricId]`) and every widget's data, since widgets
 * draw target lines. The metric id comes from `metric_id` when the confirm
 * response carries one, else from `url_path`.
 *
 * @param {Object} result - the confirm response (`kind`, `url_path`, …)
 * @param {import('@tanstack/react-query').QueryClient} [queryClient]
 */
export function invalidateAfterConfirm(result, queryClient = appQueryClient) {
  if (result?.kind !== 'target') return
  const metricId = result.metric_id ?? metricIdFromPath(result.url_path)
  if (metricId != null) queryClient.invalidateQueries({ queryKey: [METRIC_TARGETS_QUERY_KEY, String(metricId)] })
  queryClient.invalidateQueries({ queryKey: ['widget-data'] })
  queryClient.invalidateQueries({ queryKey: ['number-widget-data'] })
}
